import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ebfd10b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = {
  key: 0,
  class: "DialogBody",
  style: {"width":"auto","max-width":"none"}
}
const _hoisted_4 = { class: "W-100" }
const _hoisted_5 = {
  class: "DialogSection",
  id: "TableToPrint1",
  style: {"gap":"0"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pagebreak CookiesRowSpacer JustPrint" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "W-100 D-Flex JustPrint",
  style: {"text-align":"start"}
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pagebreak CookiesRowSpacer" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pagebreak CookiesRowSpacer" }, null, -1))
const _hoisted_12 = {
  class: "D-Flex",
  style: {"gap":"1em"}
}
const _hoisted_13 = { class: "F-Bold M-Auto" }
const _hoisted_14 = {
  class: "DialogSection",
  id: "TableToPrint2"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pagebreak CookiesRowSpacer JustPrint" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pagebreak CookiesRowSpacer JustPrint" }, null, -1))
const _hoisted_17 = {
  key: 0,
  class: "pagebreak F1_5em CookiesRowSpacer JustPrint"
}
const _hoisted_18 = {
  key: 1,
  class: "pagebreak F1_5em CookiesRowSpacer JustPrint"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pagebreak CookiesRowSpacer JustPrint" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pagebreak CookiesRowSpacer JustPrint" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRow F-C2" }, null, -1))
const _hoisted_23 = {
  key: 1,
  class: "DialogBody",
  style: {"width":"auto","max-width":"none"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesDonutCard = _resolveComponent("CookiesDonutCard")!
  const _component_CookiesTable = _resolveComponent("CookiesTable")!
  const _component_CookiesLoading = _resolveComponent("CookiesLoading")!

  return (_openBlock(), _createElementBlock("div", {
    id: 'CookiesDialog_' + _ctx.DialogIndex,
    class: "CookiesDialogdBody"
  }, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.Loading.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_CookiesDonutCard, {
                style: {"height":"300px"},
                CustomData: _ctx.ChartData,
                GroupBy: 'TransferItemItemID'
              }, null, 8, ["CustomData"]),
              _createElementVNode("div", _hoisted_5, [
                (_ctx.MoreDetails)
                  ? (_openBlock(), _createBlock(_component_CookiesTable, {
                      key: 0,
                      class: "Shadow1",
                      TableSettings: _ctx.TableSettings,
                      CookiesData: _ctx.CombinedItems
                    }, null, 8, ["TableSettings", "CookiesData"]))
                  : _createCommentVNode("", true),
                _hoisted_6,
                (!_ctx.MoreDetails)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.MoreDetails = true)),
                      class: "CookiesButton Shadow1"
                    }, _toDisplayString(_ctx.Translate('Details')), 1))
                  : _createCommentVNode("", true),
                _hoisted_7,
                _hoisted_8,
                _hoisted_9
              ]),
              _hoisted_10,
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1))),
                  class: "PrintButton Shadow2 BGRed D-Flex RowMargin NOPRINT",
                  style: {"background-color":"var(--colorr1)"}
                }, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.Translate('Close')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _hoisted_16,
                ((_ctx.DialogData?.Data.Type === 'Import' || _ctx.DialogData?.Data.Type === 'ExternalImport'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.Translate('processing inputs')), 1))
                  : _createCommentVNode("", true),
                (_ctx.DialogData?.Data.Type === 'Export' || _ctx.DialogData?.Data.Type === 'BranchesTransfer')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.Translate('order processing')), 1))
                  : _createCommentVNode("", true),
                _hoisted_19,
                _hoisted_20
              ])
            ]),
            _hoisted_21,
            _hoisted_22
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createVNode(_component_CookiesLoading)
          ]))
    ])
  ], 8, _hoisted_1))
}